import Vue from 'vue';

// remove html tags and crop at selected character and append selected string
Vue.filter('crop', (text, stop, clamp) => text.replace(/<(?:.|\n)*?>/gm, '').slice(0, stop) + (stop < text.length ? clamp || '...' : ''));
